import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sprintService } from '@services';

export const useSprints = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['sprints', params],
    queryFn: () => sprintService.getAll(params),
    enabled: options.enabled !== undefined ? options.enabled : !!params.projectId,
    ...options,
  });
};

export const useSprint = (id) => {
  return useQuery({
    queryKey: ['sprint', id],
    queryFn: () => sprintService.getById(id),
    enabled: !!id,
  });
};

export const useCreateSprint = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sprintService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sprints'] });
    },
  });
};

export const useUpdateSprint = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => sprintService.update(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['sprints'] });
      queryClient.invalidateQueries({ queryKey: ['sprint', id] });
    },
  });
};

export const useDeleteSprint = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sprintService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sprints'] });
    },
  });
};

export const useStartSprint = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sprintService.start,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sprints'] });
    },
  });
};

export const useCompleteSprint = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, moveUnfinishedTo }) => sprintService.complete(id, moveUnfinishedTo),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sprints'] });
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
};
